import { render, staticRenderFns } from "./external-validation.vue?vue&type=template&id=ee4e23ea&"
import script from "./external-validation.vue?vue&type=script&lang=ts&"
export * from "./external-validation.vue?vue&type=script&lang=ts&"
import style0 from "./external-validation.vue?vue&type=style&index=0&id=ee4e23ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports